import { useEffect } from 'react';

// Extend the Window interface to include OrokiipayWidget
declare global {
  interface Window {
    OrokiipayWidget: {
      createWidget: (param: string) => HTMLElement;
    };
  }
}

const OrokiiPayWidgetLoader = () => {
  useEffect(() => {
    // Create a script element
    const script = document.createElement('script');

    // Set the script source to the remote-widgets.js file
    script.src = 'https://orokiipay-js-widget.web.app/bundle.js';
    script.async = true;

    // Append the script to the document body
    document.body.appendChild(script);

    // Initialize the widget after the script has loaded
    script.onload = () => {
      // Assuming the widget has a createWidget function
      const container = document.getElementById('orokii-pay-widget-container');
      if (container && window.OrokiipayWidget) {
        const widget = window.OrokiipayWidget.createWidget("200"); // Pass any required parameters
        container.appendChild(widget);
      } else {
        console.error('OrokiipayWidget is not defined or container is not found.');
      }
    };

    // Cleanup: Remove the script element when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default OrokiiPayWidgetLoader;